// ============================================================
// coordenadas.js — leitura das coordenadas do núcleo
//
// O coordenador não digita latitude e longitude à mão: ele abre o local
// no Google Maps, clica com o botão direito e escolhe a primeira opção,
// que copia algo como "-3.743614, -38.536156". Este módulo aceita esse
// texto colado exatamente como veio.
//
// Também aceita as variações que aparecem quando o valor passa por uma
// planilha ou é digitado por outra pessoa: ponto e vírgula no lugar da
// vírgula separadora, vírgula decimal em vez de ponto, espaços sobrando
// e parênteses em volta.
// ============================================================

// Aceita "-3.74, -38.53" e também "-3,74; -38,53".
//
// A ambiguidade da vírgula (separa os dois números ou é a casa decimal?)
// é resolvida pelo ponto e vírgula quando ele existe; sem ele, a regra é
// que a vírgula separa os números, que é o formato do Google Maps.
export function lerCoordenadas(texto) {
  const bruto = String(texto || "").trim().replace(/^\(|\)$/g, "");
  if (!bruto) return null;

  const separador = bruto.includes(";") ? ";" : ",";
  const partes = bruto.split(separador);
  if (partes.length !== 2) return null;

  // Com ponto e vírgula separando, a vírgula que sobrar é decimal.
  const normalizar = (p) =>
    Number(
      (separador === ";" ? p.replace(",", ".") : p).trim()
    );

  const lat = normalizar(partes[0]);
  const lng = normalizar(partes[1]);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90) return null;
  if (lng < -180 || lng > 180) return null;

  return { lat, lng };
}

// Formata para exibição e para preencher o campo na edição, no mesmo
// formato que o Google Maps entrega — assim o valor mostrado pode ser
// copiado de volta para o mapa sem ajuste.
export function formatarCoordenadas(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";
  return `${lat}, ${lng}`;
}
